import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    saveCollectionType,
    getAll,
    editData,
    getAllProductIDForDropdown,
    
};

async function saveCollectionType(data){
    let collectionType = {
        collectionTypeMasterID: 0,
        collectionTypeCode: data.collectionTypeCode,
        collectionTypeName: data.collectionTypeName.trim(),
        productID: parseInt(data.productID),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/CollectionType/SaveCollectionType', null, collectionType);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/CollectionType/GetAllCollectionType', null);
    return response.data;
}

async function editData(data) {
    data.collectionTypeName = data.collectionTypeName.trim();
    data.modifiedDate = new Date().toISOString();
    data.productID = parseInt(data.productID);
    console.log(data);
    const response = await CommonPost('/api/CollectionType/UpdateCollectionType', null, data);
    return response;
}

async function getAllProductIDForDropdown() {
    var productArray = []

    const response = await CommonGet('/api/Product/GetProducts', null);
    for (let item of Object.entries(response.data)) {
        productArray[item[1]["productID"]] = item[1]["productName"]
    }

    return productArray;
}




